import React from "react";
import { Col } from "react-bootstrap";
/**Content Item takes props: position ("left" or "right"), label, and content for that label (can be JSX) */
export const ContentItem = (props) => {

    const orientation = () => {
        var orientationRet = "d-flex justify-content-start"
        if (props.position !== undefined || props.position !== null) {
            if (props.position === "right") {
                // orientationRet = "d-flex justify-content-end";
                orientationRet = "d-flex justify-content-start";
            }
            else if (props.position === "most-right") {
                orientationRet = "d-flex justify-content-end";
            }
        }
        return orientationRet;
    }
    return(
            <Col 
                className={orientation()}
                style={{
                    marginTop: "3px"
                    ,marginBottom: "3px"
                }}>
                
                <div 
                    style={{
                        whiteSpace: 'pre-wrap'
                        ,wordWrap: 'break-word'
                        // ,borderColor: '#b8daff'
                        // ,borderRadius: '10px'
                        // ,backgroundColor: "#cce5ff"
                        ,color: "black"
                        ,paddingLeft: '2px'
                        ,paddingRight: '2px'
                        // ,textAlign: "center"  
                        ,verticalAlign: 'middle'        
                    }}
                ><strong>{props.label ? props.label + ":" : ""}</strong></div>
                <div 
                    style={{
                        // color: '#3296FA'
                        color: 'black'
                        , marginLeft: '3px'
                    }}
                >
                    {props.content}
                </div>
            </Col>
    )
}